import React, { useEffect, useState, useRef } from "react";
import Styles from "../../../assets/css/Blogs/RealLifeGadgets/ElectricSpinScrubber.module.css";
import { useGlobalState } from "../../../Functions/GlobalStates";
import debounce from "lodash.debounce";
import Loading from "../../Loadings/Loading";
import { Helmet } from "react-helmet-async";

const ElectricSpinScrubber = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();
  // React Elements References Here //////////////////////////////////// ...............
  const CheckPageStateRef = useRef(false); // Ref for the check Page
  const ElectricSpinScrubber = useRef(false); // Ref for the absolute box

  const ProductImages = require.context(
    "../../../assets/images/Blogs/RealLifeGadgets/ElectricSpinScrubber",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const ProductImagesArray = [
    ProductImages("./33.avif"),
    ProductImages("./35.avif"),
    ProductImages("./38.avif"),
    ProductImages("./40.avif"),
    ProductImages("./41.avif"),
  ];

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([ProductImagesArray[0]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (ElectricSpinScrubber.current) {
        const { width, height } =
          ElectricSpinScrubber.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return IsLoaded ? (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Electric Spin Scrubber - Must-Have Cleaning Gadget</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover the Electric Spin Scrubber – the ultimate cleaning gadget for 2025. Effortless, hands-free cleaning with powerful spin speeds, adjustable angles, and versatile brush heads."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Electric Spin Scrubber, best cleaning gadget 2025, cordless scrubber, home cleaning tool, effortless cleaning device"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Electric Spin Scrubber - Must-Have Cleaning Gadget"
        />
        <meta
          property="og:description"
          content="Discover the Electric Spin Scrubber – the ultimate cleaning gadget for 2025. Effortless, hands-free cleaning with powerful spin speeds, adjustable angles, and versatile brush heads."
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/reallifegadgets/electricspinscrubber"
        />
        {/* <meta
          property="og:image"
          content="/images/ElectricSpinScrubber/33.png"
        /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Electric Spin Scrubber - Must-Have Cleaning Gadget"
        />
        <meta
          name="twitter:description"
          content="Discover the Electric Spin Scrubber – the ultimate cleaning gadget for 2025. Effortless, hands-free cleaning with powerful spin speeds, adjustable angles, and versatile brush heads."
        />
        {/* <meta
          name="twitter:image"
          content="/images/ElectricSpinScrubber/33.png"
        /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/reallifegadgets/electricspinscrubber"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div
        ref={ElectricSpinScrubber}
        className={Styles.ElectricSpinScrubberContainer}
      >
        <section className={Styles.ElectricSpinScrubberSection1}>
          <div
            className={Styles.ElectricSpinScrubberSection1Text1Container}
          ></div>
          <img
            src={`${ProductImagesArray[0]}`}
            alt="Electric Spin Scrubber"
            title="This is an AI-generated representation. Actual product may vary."
          />
          <p>
            These images are AI-generated representations of the products.
            Actual appearance, specifications, features, and colors may vary.
            For the most accurate and up-to-date product details, please refer
            to the official product page via the button at the end of this blog.
          </p>
          <div className={Styles.ElectricSpinScrubberSection1Text2Container}>
            <h1>| Electric Spin Scrubber |</h1>
            <h1>Struggling with Stubborn Stains? Not Anymore!</h1>
            <p>
              Cleaning tough grime, soap scum, and mold in your bathroom,
              kitchen, or floors can be exhausting. But what if you had a
              powerful, hands-free cleaning assistant to do the hard work for
              you? The Electric Spin Scrubber is designed to make deep cleaning
              effortless and efficient—so you spend less time scrubbing and more
              time enjoying a sparkling clean home.
            </p>
          </div>
          <div className={Styles.ElectricSpinScrubberSection1Img2Container}>
            <img
              src={`${ProductImagesArray[2]}`}
              alt="Electric Spin Scrubber"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[3]}`}
              alt="Electric Spin Scrubber"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.ElectricSpinScrubberSection1Text3Container}>
            <h1>Why This Scrubber Stands Out</h1>
            <p>
              <span style={{ color: "black" }}>
                ✅ Remote-Controlled Cleaning for Ultimate Convenience{" "}
              </span>{" "}
              Tired of bending and kneeling while scrubbing? This is the only
              spin scrubber with remote control functionality, allowing you to
              adjust speed or power it on/off with ease. No more aching knees or
              back pain—just effortless cleaning!
            </p>
            <p>
              <span style={{ color: "black" }}>
                🌀 Dual-Speed Power for Deep Cleaning{" "}
              </span>{" "}
              Tackle all kinds of messes with two powerful spin speeds (350RPM &
              450RPM). Whether it's delicate surfaces or stubborn grime, you can
              choose the perfect speed for maximum cleaning power.
            </p>
            <p>
              <span style={{ color: "black" }}>
                🔄 4 Adjustable Angles for Hard-to-Reach Areas
              </span>{" "}
              With four adjustable angles (90°, 120°, 150°, and 180°), this
              scrubber can effortlessly reach tight spaces, corners, and even
              high-up areas like tiled walls or ceilings. No spot goes
              uncleaned!
            </p>
            <p>
              <span style={{ color: "black" }}>
                ⚡ Fast Charging & Long Battery Life{" "}
              </span>{" "}
              Powered by an upgraded 2500mAh*2 battery, it fully charges in just
              2.5 hours and lasts up to 90 minutes—enough to clean your entire
              home in one go! Plus, an LED battery indicator keeps you informed
              about the remaining charge.
            </p>
            <p>
              <span style={{ color: "black" }}>
                🛁 8 Versatile Brush Heads for Every Surface{" "}
              </span>{" "}
              From tiles and bathtubs to wooden floors and windows, the scrubber
              comes with 8 specialized brush heads to handle any cleaning task:
              ✔ Dome Brush – Perfect for bathtubs and curved surfaces. ✔ Flat
              Brush – Ideal for floors, walls, and large surfaces. ✔ Corner
              Brush – Reaches grout, faucets, and tight edges. ✔ Cloth Brush –
              Safe for wooden floors and furniture. ✔ Sponge Pad – Gently cleans
              windows, mirrors, and delicate surfaces.
            </p>
          </div>
          <div className={Styles.ElectricSpinScrubberSection1Img3Container}>
            <img
              src={`${ProductImagesArray[1]}`}
              alt="Electric Spin Scrubber"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[4]}`}
              alt="Electric Spin Scrubber"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.ElectricSpinScrubberSection1Text4Container}>
            <h1>Effortless Cleaning Starts Here!</h1>
            <p>
              With its remote control, adjustable angles, and powerful motor,
              the Electric Spin Scrubber makes cleaning faster, easier, and
              stress-free. No more hard scrubbing—just press a button and let
              this tool do the work for you!
            </p>
          </div>
          <div className={Styles.ElectricSpinScrubberSection1Text5Container}>
            <h4>
              🔔 If you're interested, similar products are available through
              the provided sources.
            </h4>
          </div>
          <a
            title="This link leads to an affiliate product page. We may earn a commission at no extra cost to you."
            href="https://amzn.to/3QlmMCe"
            target="_blank"
            rel="noopener noreferrer"
            className={
              Styles.ElectricSpinScrubberSection1BtnAmazonAncherContainer
            }
          >
            <button
              title="This button leads to an affiliate product page. We may earn a commission at no extra cost to you."
              className={Styles.ElectricSpinScrubberSection1BtnAmazon}
            >
              Buy Now on <span>&nbsp;&nbsp;Amazon</span> <span>&nbsp;»</span>
            </button>
          </a>
          <div
            className={Styles.ElectricSpinScrubberSection1DesclaimerContainer}
          >
            <h1>Affiliate Disclaimer 💬</h1>
            <p>
              As an Amazon Associate, I earn from qualifying purchases. This
              helps support the blog at no extra cost to you.
            </p>
            <h1>AI-Generated Images Disclaimer</h1>
            <p>
              The product images on this site are AI-generated representations
              created for illustrative purposes only. They may not perfectly
              match the actual product in terms of color, design, or features.
              For accurate details and images, please refer to the official
              product listing on Amazon by clicking the provided links.
            </p>
            <h1>HashTags</h1>
            <p>
              #CleaningGadget #HomeCleaning #CordlessScrubber #DeepCleaning
              #CleaningTool #SmartCleaning #HouseholdEssentials #EasyCleaning
              #MultipurposeCleaner #FindTheBest
            </p>
            <h1>Keywords</h1>
            <p>
              Best cordless cleaning brush for 2025 home cleaning Powerful
              rechargeable scrubber for effortless cleaning Multi-purpose
              cleaning tool for tiles, sinks, and floors Adjustable cleaning
              brush with interchangeable heads Lightweight and ergonomic design
              for easy use Water-resistant cleaning device for bathrooms and
              kitchens Time-saving cleaning gadget for a spotless home
            </p>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default ElectricSpinScrubber;
